import { render, staticRenderFns } from "./ContractPic.vue?vue&type=template&id=586fa761&"
import script from "./ContractPic.vue?vue&type=script&lang=js&"
export * from "./ContractPic.vue?vue&type=script&lang=js&"
import style0 from "./ContractPic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('586fa761')) {
      api.createRecord('586fa761', component.options)
    } else {
      api.reload('586fa761', component.options)
    }
    module.hot.accept("./ContractPic.vue?vue&type=template&id=586fa761&", function () {
      api.rerender('586fa761', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/ContractPic.vue"
export default component.exports